import React from 'react'

export const CheckoutUrgencyContext = React.createContext(null)
